import { PropsWithChildren } from 'react';

import { useAtomValue } from 'jotai';
import { ScopeProvider } from 'jotai-scope';

import { activityAtom, activitySwingsAtom } from '../atoms/activity/activity';
import {
    playback3dCameraSphericalAtom,
    playback3dCameraTargetAtom,
    playback3dCurrentViewPresetAtom,
    playback3dFreezePositionAtom,
    playback3dOverlayComparisonAtom,
    playback3dSelectedParamsAtom,
} from '../atoms/activity/visualizer';
import { activityIdAtom } from '../atoms/global/url';
import { cameraViewsAtom, pendingScrubberLockAtom, progressAtom, scrubberLockAtom } from '../atoms/swing/playback';
import { comparisonAnalysisAtom, comparisonVideoAtom } from '../atoms/swing/swings';
import { layoutAtom, layoutCustomizationsAtom } from '../atoms/user/layout';
import { activeUserSettingsAtom } from '../atoms/user/user';

export const ActivityScope = ({ children }: PropsWithChildren) => {
    const activityId = useAtomValue(activityIdAtom);
    return (
        <ScopeProvider
            key={activityId}
            atoms={[
                activityAtom,
                activitySwingsAtom,
                comparisonAnalysisAtom,
                comparisonVideoAtom,
                activeUserSettingsAtom,
                layoutAtom,
                layoutCustomizationsAtom,
                progressAtom,
                scrubberLockAtom,
                pendingScrubberLockAtom,
                playback3dSelectedParamsAtom,
                playback3dFreezePositionAtom,
                playback3dCurrentViewPresetAtom,
                playback3dOverlayComparisonAtom,
                playback3dCameraSphericalAtom,
                playback3dCameraTargetAtom,
                cameraViewsAtom,
            ]}
        >
            {children}
        </ScopeProvider>
    );
};

export const withActivityScope = <C extends React.ComponentType<any>>(Component: C) => {
    type Props = React.ComponentProps<C>;

    const Wrapped = (props: Props) => (
        <ActivityScope>
            <Component {...props} />
        </ActivityScope>
    );

    Wrapped.displayName = `withActivityScope(${Component.displayName ?? Component.name ?? 'Component'})`;
    return Wrapped;
};
